import './UI_LIBRARY.scss';
import 'extensions/product-card/product-card.scss';
import ProductSwatches from 'extensions/product-card/ProductSwatches';
import 'extensions/sections/sections.scss';
import 'extensions/carousel/carousel.scss';
import 'extensions/accordions/accordions.scss';
import 'extensions/accordions/accordions';
import {PageManager} from '@mvps-genesis/bootstrap';
import { initializeCarousels } from 'extensions/carousel/carousel';

export default class UI_LIBRARY extends PageManager {

	constructor( pageContext ) {

		super( pageContext );

	}

	onReady() {

		const self = this;

		new ProductSwatches();
		initializeCarousels();

	}

}
